<template>
  <form autocomplete="new-password" class="NoEventsOnLoading">
    <input type="hidden" autocomplete="new-password" />

    <div
      v-if="!readonly"
      class="form-group"
      :class="{ WRNG: form.conectxid.invalid }"
    >
      <b>Instituția</b>
      <v-select-infinite
        name="I8"
        v-model="form.institution.value"
        label="name"
        :apiModule="institutionApiModule"
        :totalOptions="totalOptions"
        :totalRecordsCount="totalRecordsCount"
        :excludeClones="excludeClones"
        :startup="!form.institution.readonly"
        :no-drop="form.institution.readonly"
        :clearable="!form.institution.readonly"
        :disabled="form.institution.readonly"
        @totalRecordsCount="(e) => (totalRecordsCount = e)"
      >
      </v-select-infinite>
    </div>
    <div class="Popup_body_cols">
      <div class="Popup_body_col">
        <div class="form-group" :class="{ WRNG: form.conectxid.invalid }">
          <b>ConectX ID</b>
          <div style="display: flex; align-items: center">
            <input
              type="number"
              name="I7"
              v-model="form.conectxid.value"
              class="vInput"
              min="0"
              :style="!readonly ? 'margin-right: 5px' : ''"
              :disabled="readonly"
              :class="{ 'form-disabled': readonly }"
            />
            <button
              v-if="!readonly"
              v-tooltip="{ content: 'Sincronizare utilizator' }"
              class="Button2"
              @click.prevent="syncUser()"
            >
              <i class="fas fa-sync" :class="{ rotating: loadUser }"></i>
            </button>
          </div>
        </div>
        <div class="form-group" :class="{ WRNG: form.name.invalid }">
          <b>Nume</b>
          <input
            name="I1"
            v-model="form.family.value"
            class="vInput form-disabled"
            autocomplete="new-password"
            autocapitalize="false"
            autocorrect="false"
            disabled
          />
        </div>
        <div class="form-group" :class="{ WRNG: form.family.invalid }">
          <b>Prenume</b>
          <input
            type="text"
            name="I2"
            v-model="form.name.value"
            class="vInput form-disabled"
            autocomplete="new-password"
            autocapitalize="false"
            autocorrect="false"
            disabled
          />
        </div>
        <!-- <div class="form-group" :class="{ WRNG: form.cnp.invalid }">
          <b>
            CNP
            <template v-if="form.cnp.value">
              <i
                v-if="statuses.cnpIsValid"
                class="fas fa-check-circle"
                v-tooltip="'Formatul este introdus corect.'"
                style="color: #43b645"
              ></i>
              <i
                v-else
                class="fas fa-times-circle"
                v-tooltip="'Formatul nu este introdus corect.'"
                style="color: #c84d4d"
              ></i>
            </template>
          </b>
          <div
            class="form-status"
            :class="{
              fActive: statuses.cnpIsUnique !== false,
              fPositive: statuses.cnpIsUnique === 1,
              fNegative: statuses.cnpIsUnique === 2,
            }"
          >
            <input
              type="text"
              name="I3"
              v-model="form.cnp.value"
              class="vInput"
              autocomplete="new-password"
              autocapitalize="false"
              autocorrect="false"
            />
            <span>
              <i
                v-if="statuses.cnpIsUnique === true"
                class="fas fa-sync fa-spin"
              ></i>
              <i
                v-if="statuses.cnpIsUnique === 1"
                class="fas fa-check"
                style="color: #43b645"
                v-tooltip="'Acest CNP este unic!'"
              ></i>
              <i
                v-if="statuses.cnpIsUnique === 2"
                class="fas fa-times-circle"
                style="color: #c84d4d"
                v-tooltip="{
                  content: 'Acest CNP deja există!',
                  offset: 2,
                }"
              ></i>
            </span>
          </div>
        </div> -->
      </div>
      <div class="Popup_body_col">
        <div class="form-group" :class="{ WRNG: form.username.invalid }">
          <b>Username</b>
          <div
            class="form-status"
            :class="{
              fActive: statuses.usernameIsUnique !== false,
              fPositive: statuses.usernameIsUnique === 1,
              fNegative: statuses.usernameIsUnique === 2,
            }"
          >
            <input
              type="text"
              name="I3"
              v-model="form.username.value"
              class="vInput form-disabled"
              autocomplete="new-password"
              autocapitalize="false"
              autocorrect="false"
              disabled
            />
            <span>
              <i
                v-if="statuses.usernameIsUnique === true"
                class="fas fa-sync fa-spin"
              ></i>
              <i
                v-if="statuses.usernameIsUnique === 1"
                class="fas fa-check"
                style="color: #43b645"
                v-tooltip="'Acest username este unic!'"
              ></i>
              <i
                v-if="statuses.usernameIsUnique === 2"
                class="fas fa-times-circle"
                style="color: #c84d4d"
                v-tooltip="{
                  content: 'Acest username deja există!',
                  offset: 2,
                }"
              ></i>
            </span>
          </div>
        </div>
        <div class="form-group" :class="{ WRNG: form.email.invalid }">
          <b
            >E-mail corespondență
            <template v-if="form.email.value">
              <i
                v-if="statuses.emailIsValid"
                class="fas fa-check-circle"
                v-tooltip="'Formatul este introdus corect.'"
                style="color: #43b645"
              ></i>
              <i
                v-else
                class="fas fa-times-circle"
                v-tooltip="'Formatul nu este introdus corect.'"
                style="color: #c84d4d"
              ></i> </template
          ></b>
          <div
            class="form-status"
            :class="{
              fActive: statuses.emailIsUnique !== false,
              fPositive: statuses.emailIsUnique === 1,
              fNegative: statuses.emailIsUnique === 2,
            }"
          >
            <input
              type="text"
              name="I5"
              v-model="form.email.value"
              class="vInput form-disabled"
              autocomplete="new-password"
              autocapitalize="false"
              autocorrect="false"
              disabled
            />
            <span>
              <i
                v-if="statuses.emailIsUnique === true"
                class="fas fa-sync fa-spin"
              ></i>
              <i
                v-if="statuses.emailIsUnique === 1"
                class="fas fa-check"
                style="color: #43b645"
                v-tooltip="'Acest email este unic!'"
              ></i>
              <i
                v-if="statuses.emailIsUnique === 2"
                class="fas fa-times-circle"
                style="color: #c84d4d"
                v-tooltip="{
                  content: 'Acest email deja există!',
                  offset: 2,
                }"
              ></i>
            </span>
          </div>
        </div>
        <div
          class="form-group VTY-margin_1"
          :class="{ WRNG: form.phone.invalid }"
        >
          <b
            >Telefon
            <template v-if="form.phone.value">
              <i
                v-if="phoneValid"
                class="fas fa-check-circle"
                v-tooltip="'Formatul este introdus corect.'"
                style="color: #43b645"
              ></i>
              <i
                v-else
                class="fas fa-times-circle"
                v-tooltip="'Formatul nu este introdus corect.'"
                style="color: #c84d4d"
              ></i>
            </template>
          </b>
          <vue-tel-input
            @input="(a, b) => (statuses.phoneStatus = b || null)"
            v-model="form.phone.value"
            :inputOptions="{
              styleClasses: 'form-disabled',
            }"
            disabled
          />
        </div>
      </div>
    </div>
    <div v-if="showResetBtn || showResendActivationBtn" align="left">
      <div class="hr1" style="margin-bottom: 1rem"></div>
      <div class="user-action-btn-group">
        <div
          v-if="showResetBtn"
          @click="$emit('requestPasswordReset')"
          class="Button1"
        >
          <div class="icon">
            <i class="fa-solid fa-key"></i>
          </div>
          <span class="Btn_content"> Cere resetare parolă </span>
        </div>

        <div
          v-if="showResendActivationBtn"
          @click="$emit('resendActivation')"
          class="Button1"
        >
          <div class="icon"><i class="fa-solid fa-repeat"></i></div>
          <span class="Btn_content"> Retrimitere activare cont </span>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { USERS_SEARCH, INSTITUTIONS_PAGINATED, USER_SYNC } from "@/api.js";

const defaultFormData = () => ({
  name: {
    value: "",
    invalid: false,
  },
  family: {
    value: "",
    invalid: false,
  },
  username: {
    value: "",
    invalid: false,
  },
  email: {
    value: "",
    invalid: false,
  },
  phone: {
    value: "",
    invalid: false,
  },
  conectxid: {
    value: undefined,
    invalid: false,
  },
  institution: {
    value: undefined,
    invalid: false,
    readonly: false,
  },
});
const defaultStatuses = () => ({
  cnpIsValid: false,
  cnpIsUnique: false,
  usernameIsUnique: false,
  emailIsUnique: false,
  emailIsValid: false,
  phoneStatus: false,
});

const modal20KeysMap = {
  name: "Input1",
  family: "Input2",
  username: "Input4",
  email: "Input5",
  phone: "Input6",
  conectxid: "Input7",
  institution: "Input8",
};
const modal20StatusesKeysMap = {
  cnpIsUnique: "cnpIsOk",
  usernameIsUnique: "usernameIsOk",
  emailIsUnique: "emailIsUnique",
  phoneStatus: "phoneStatus",
};

const safeApi = window["apiTimeout"](400, false, false, true);

export default {
  props: {
    Modal20: {
      type: [Boolean, Object],
      default: false,
    },
    showResetBtn: {
      type: Boolean,
      default: false,
    },
    showResendActivationBtn: {
      type: Boolean,
      default: false,
    },
    checkerCount: {
      type: Number,
      default: 0,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: defaultFormData(),
      statuses: defaultStatuses(),
      initialModal20: null,
      institutionApiModule: INSTITUTIONS_PAGINATED,
      totalOptions: [],
      totalRecordsCount: 0,
      selected: [],
      loadUser: false,
    };
  },
  computed: {
    phoneValid() {
      return this.statuses.phoneStatus?.valid === true;
    },
    oldFormData() {
      return this.deepClone(this.form);
    },
    excludeClones() {
      return this.selected.filter((e) => e.value?.id).map((e) => e.value.id);
    },
  },
  watch: {
    statuses: {
      handler() {
        this.syncChanges();
      },
      deep: true,
    },
    oldFormData: {
      handler(curr, old) {
        const trim = (str) => String(str).trim();

        const checkerError = (ctx, msg) => {
          if (ctx && Array.isArray(ctx[0])) {
            ctx = ctx[0];

            if (ctx[2]) {
              this.$toastr.e(
                `Verificarea identității pentru ${ctx[2]} a eșuat${
                  msg ? `: ${msg}` : "."
                }`
              );
            }
          }
        };
        const apiCheckerMap = {
          cnp: [
            ["cnp", "cnpIsUnique", "codul cpv", "cnpIsValid"], // keys map
            (val) => {
              val = val || "";

              const checker = (start, length, fromTo, value, prepareFn) => {
                fromTo = fromTo || [];

                const segment = val.substr(start, length);
                const x = +segment;

                if (!trim(segment) || isNaN(x)) {
                  return false;
                }

                let isValid = false;
                for (let e of fromTo) {
                  if (Number.isInteger(e) && e === x) {
                    isValid = true;
                    break;
                  }

                  if (Array.isArray(e) && x >= e[0] && x <= e[1]) {
                    isValid = true;
                    break;
                  }
                }
                return (
                  isValid && (prepareFn ? prepareFn(value, segment) : true)
                );
              };

              const checkMap = [
                [0, 1, [[1, 8]]],
                [1, 2, [[0, 99]]],
                [3, 2, [[1, 12]]],
                [5, 2, [[1, 31]]],
                [
                  7,
                  2,
                  [
                    [1, 48],
                    [51, 52],
                  ],
                ],
                [9, 3, [[1, 999]]],
                [
                  12,
                  1,
                  [[0, 9]],
                  (value, char) => {
                    if (!value || !char) return false;

                    const checkingSegment = value?.slice(0, 12);
                    const key = "279146358279";

                    let prepareSum = 0;
                    for (let i = 0; i < checkingSegment.length; i++) {
                      let findInt = +checkingSegment[i];
                      if (isNaN(findInt)) return false;

                      prepareSum += findInt * +key[i];
                    }
                    prepareSum = prepareSum % 11;
                    if (prepareSum === 10) prepareSum = 1;

                    return prepareSum === +char;
                  },
                ],
              ];

              if (trim(val).length !== 13) {
                return false;
              }

              for (let e of checkMap) {
                e.splice(3, 0, val);
                if (!checker(...e)) {
                  return false;
                }
              }

              return true;
            },
          ],
          username: [
            ["email", "usernameIsUnique", "username"],
            (val) => trim(val).length > 2,
          ],
          email: [
            ["emailForCommunication", "emailIsUnique", "email", "emailIsValid"],
            (val) => trim(val).length > 2 && this.validateEmail(val),
          ],
        };
        const personNameChecker = /[^a-zA-ZăîâșțĂÎÂȘȚ]/;

        const validateValuesMap = {
          //name: (val) => val?.replace(personNameChecker, ""),
          //family: (val) => val?.replace(personNameChecker, ""),
          cnp: (val) => val?.replace(/[^\d]/, "").substr(0, 13),
          phone: (val) => val?.replace(/[^\d+ ]/, ""),
          //conectxid: (val) => val?.replace(/[^\d ]/, ""),
        };

        for (let e of Object.entries(curr)) {
          const key = e[0];
          const val = e[1].value;

          if (typeof validateValuesMap[key] == "function") {
            this.$nextTick(
              () => (this.form[key].value = validateValuesMap[key](val))
            );
          }

          if (val !== old[key].value) {
            this.form[key].invalid = false;

            const x = apiCheckerMap[key];

            if (Array.isArray(x)) {
              const keysMap = x[0];
              const setStatus = (val) => (this.statuses[keysMap[1]] = val);
              const setValidationStatus = (val) =>
                keysMap[3] ? (this.statuses[keysMap[3]] = val) : undefined;

              if (typeof x[1] == "function" && x[1](val)) {
                setValidationStatus(true);

                if (val === this.initialModal20[modal20KeysMap[key]]) {
                  setStatus(3);
                  continue;
                }
                safeApi(() => {
                  setStatus(true);
                  USERS_SEARCH(keysMap[0], val)
                    .then((res) => {
                      if (val !== this.form[key].value) {
                        return;
                      }

                      if (!Number.isInteger(res?.data?.recordsQuantity)) {
                        checkerError(x);
                        return;
                      }
                      if (res.data.recordsQuantity > 0) {
                        setStatus(2);
                      } else {
                        setStatus(1);
                      }
                    })
                    .catch((err) => checkerError(x, err));
                });
              } else if (keysMap) {
                setValidationStatus(false);
                setStatus(false);
              }
            }
          }
        }

        this.syncChanges();
      },
      deep: true,
    },
    checkerCount() {
      this.checkValid();
    },
  },
  methods: {
    checkValid() {
      const trim = (str) => String(str).trim();

      for (let e of Object.entries(this.form)) {
        if (!trim(e[1].value) || !e[1].value) {
          e[1].invalid = true;
        }
      }
    },

    syncChanges(readChanges) {
      if (!this.Modal20) {
        return;
      }

      if (!this.initialModal20) {
        this.initialModal20 = this.deepClone(this.Modal20);
      }

      for (let e of Object.entries(modal20KeysMap)) {
        if (readChanges) {
          this.form[e[0]].value = this.Modal20[e[1]];
        } else {
          this.Modal20[e[1]] = this.form[e[0]].value;
        }
      }

      for (let e of Object.entries(modal20StatusesKeysMap)) {
        if (readChanges) {
          this.statuses[e[0]] = this.Modal20[e[1]];
        } else {
          const v = ((x) => (x === 3 ? 1 : x))(this.statuses[e[0]]);
          this.Modal20[e[1]] = v;
        }
      }
    },

    async syncUser() {
      const error = (msg) => {
        if (msg) this.$toastr.e(msg);
        this.setLoad();
        this.loadUser = false;
      };

      if (!this.form.institution.value) {
        this.$toastr.w("Trebuie să selectați instituția");
        return;
      }

      if (!this.form.conectxid.value) {
        this.$toastr.w("Trebuie să introduceți ConectX ID");
        return;
      }

      this.loadUser = true;

      this.setLoad(true);

      await USER_SYNC({
        institutionId: this.form.institution.value.id,
        conectxId: this.form.conectxid.value,
      })
        .then((res) => {
          if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
            this.loadUser = false;
            this.setLoad();
            const userInfo = res.data;
            this.form.name.value = userInfo.first_name;
            this.form.family.value = userInfo.last_name;
            this.form.username.value = userInfo.username;
            this.form.email.value = userInfo.email;
            this.form.phone.value = userInfo.phone;
          } else {
            error(res.response.message);
          }
        })
        .catch((err) => {
          error(err.message);
        });
    },
  },
  created() {
    this.syncChanges(true);

    if (this.getUserRole() !== "superadmin") {
      this.form.institution.readonly = true;
      this.form.institution.value = this.getUserInstitution(true);
    }
  },
};
</script>

<style scoped>
.user-action-btn-group {
  display: flex;
  gap: 1rem;
  width: fit-content;
}

@media (max-width: 550px) {
  .user-action-btn-group {
    flex-direction: column;
  }
}
</style>
